export function getView(medicalFormEnabled) {
  return medicalFormEnabled ? 'MedicalForm' : 'Form'
}
